/**
 * Date formatter helper a JobDetailView "Közzétéve" blokkhoz.
 *
 * [F-12 T-2.4 / D-8] Edge case-eket kezel:
 *  - undefined / null / üres → null
 *  - '0000-00-00' prefix (MySQL invalid date) → null
 *  - Cross-browser Safari/Firefox 'Y-m-d H:i:s' parse inkonzisztencia kezelése MANUÁLIS parse-szal
 *    (Codex 2. note: ne támaszkodj sima `new Date('Y-m-d H:i:s')`-re)
 *
 * Visszaadott formátum: a megadott `locale`-nak megfelelő lokalizált hosszú dátum
 * (pl. magyar: "2026. május 21.", angol: "May 21, 2026").
 */
export function formatDateForDisplay(raw, locale) {
    if (!raw)
        return null;
    const trimmed = String(raw).trim();
    if (trimmed === '')
        return null;
    if (trimmed.startsWith('0000-00-00'))
        return null;
    // Manuális 'Y-m-d' parse: az első 10 karakter szegmense
    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match)
        return null;
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const day = parseInt(match[3], 10);
    if (!year || !month || !day)
        return null;
    if (month < 1 || month > 12 || day < 1 || day > 31)
        return null;
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime()))
        return null;
    try {
        return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(date);
    }
    catch (_err) {
        // Locale nem támogatott → fallback
        return `${year}.${String(month).padStart(2, '0')}.${String(day).padStart(2, '0')}.`;
    }
}
